<template>
  <div class="modal modal-overlay" @click.self="$emit('close')">
    <div class="system-diagram-modal">
      <div class="container">
        <div class="modal-header">
          <h2>系統図新規作成</h2>
          <button class="close-button" @click="onShowSelectionDiagram">
            <div class="close-button__line close-button__line--first" @click="onShowSelectionDiagram"></div>
            <div class="close-button__line close-button__line--second" @click="onShowSelectionDiagram"></div>
          </button>
        </div>
        <div class="form">
          <div class="form-input">
            <label>系統図名称：</label>
            <input 
              type="text" 
              class="input-field" 
              v-model="diagramName" 
              name="diagramName" 
              data-vv-as="系統図名称" 
              v-validate="'required|max:64'">
            <div class="err_message">
                {{ errors.first("diagramName") }}
            </div>
          </div>
          <div class="submit_area">
            <input type="submit" class="submit" value="新規作成" @click="onRegister" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
export default {
  name: "system-diagram-register-dialog",
  data: function () {
    return {
      diagramName: '',
    };
  },
  methods: {
    onRegister: function() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.$emit('getDiagramName', this.diagramName);
        }
      });
    },
    onShowSelectionDiagram: function() {
      this.$emit('onShowSelectionDiagram');
    }
  }
};
</script>
